import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { SaleGetDocumentDTO } from '@skylab-shared/dataModel';
import { fillPlaceholders } from '@skylab-shared/utils';

export class SaleDocumentPlainObjectQuery extends Query<SaleGetDocumentDTO> { }

export class SaleDocumentPlainObjectQueryHandlerBase implements QueryHandler<SaleDocumentPlainObjectQuery, SaleGetDocumentDTO> {
    private static Url = TaggedUrl.join('sales/:id', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(_: SaleDocumentPlainObjectQuery, id: number): Promise<SaleGetDocumentDTO> {
        const { data } = await this.http.get(fillPlaceholders(SaleDocumentPlainObjectQueryHandlerBase.Url, { id: id }), {dto: SaleGetDocumentDTO});
        return data;
    }
}
